import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { auth, translate, ui } from 'parking-react-common'

import { users, routing } from '../redux'

import Avatar from '../components/Avatar'
import DropdownMenu from '../components/DropdownMenu'
import DropdownMenuItem from '../components/DropdownMenuItem'
import UserInfoItem from '../components/UserInfoItem'
import Button from '../components/Button'
import { Column, Row } from './Grid'


const UserMenu = ({ currentUser, dispatch, t }) => (
    <DropdownMenu
        name="userMenu"
        className="nav navbar-nav navbar-right be-user-nav"
        trigger={ <Avatar user={ currentUser } /> }
    >
        <UserInfoItem user={ currentUser } />
        <DropdownMenuItem
            label={ t('Account Settings') }
            link={ routing.routeFor('accountSettings') }
            icon="md/account-circle"
        />
        <DropdownMenuItem
            label={ t('Preferences') }
            link={ routing.routeFor('preferences') }
            icon="md/settings"
        />
        <DropdownMenuItem
            label={ t('Change Password') }
            link={ routing.routeFor('passwordChange') }
            icon="md/vpn-key"
        />
        <DropdownMenuItem
            label={ t('Logout') }
            onClick={ () => dispatch(
                ui.showModal({
                    title   : t('Logout'),
                    message : t('Are you sure you want to logout?'),
                    intent  : ui.INTENT.warning,
                    content : <WrappedLogoutModalContent />
                })
            ) }
            icon="md/power-settings-new"
        />
    </DropdownMenu>
)


const LogoutModalContent = ({ dispatch, t }) => (
    <div>
        <Row>
            <Column span={ 6 }>
                <Button
                    label={ t('Logout') }
                    size={ ui.SIZE.large }
                    onClick={ () => dispatch(auth.logout()) }
                    intent={ ui.INTENT.primary }
                    isBlock
                />
            </Column>
            <Column span={ 6 }>
                <Button
                    label={ t('Cancel') }
                    size={ ui.SIZE.large }
                    onClick={ () => dispatch(ui.closeModal()) }
                    isBlock
                />
            </Column>
        </Row>
    </div>
)

const WrappedLogoutModalContent = translate()(connect(mapStateToProps)(LogoutModalContent))


UserMenu.propTypes = {
    currentUser : PropTypes.object.isRequired,
    dispatch    : PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        currentUser: users.getCurrent(state)
    }
}

export default translate()(connect(mapStateToProps)(UserMenu))
